import { loggerFacet, IMeasurementInfo, internalPerfLoggerKeyFacet, internalPerfLoggerFacet } from '../facets/LoggerFacets';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { readItems } from './readItems';
import { IItemCache } from '../models/IItemCacheObserver';
import { readConfiguration } from './configuration/readConfiguration';

/**
 * Uses logger provided in the configuration, if any, to log when the component finishes rendering
 * @internal
 */
export function logPageLoad(timestamp: number, measurementInfo?: IMeasurementInfo): IItemCacheThunkAction<void> {
    return (dispatch: IItemCacheDispatch) => {
        const {
            logger
        } = dispatch(readConfiguration({
            logger: loggerFacet
        }));

        if (timestamp) {
            const internalPerfLoggerKey = internalPerfLoggerKeyFacet.serialize({});
            const internalLogger = dispatch(readItems((itemCache: IItemCache) => {
                return itemCache.demandItemFacet(internalPerfLoggerFacet, internalPerfLoggerKey);
            }));
            if (internalLogger) {
                internalLogger(timestamp, measurementInfo);
            }

            if (logger && logger.logRenderEndTime) {
                logger.logRenderEndTime(timestamp, measurementInfo);
            }
        }
    };
}
